import { HttpErrorCode } from '@copera/common/error';
import { useMutation } from '@tanstack/react-query';
import { getConversations } from 'src/redux/slices/chat';
import { dispatch } from 'src/redux/store';
import { ChatRequests } from 'src/requests/chat';

export const useDeleteChannel = () => {
  const { mutateAsync: deleteChannel, isLoading: isDeletingChannel } =
    useMutation({
      mutationFn: ChatRequests.deleteChannel,
      meta: {
        httpErrors: {
          [HttpErrorCode.UNPROCESSABLE_ENTITY]:
            'error.chat_participants.cannot_delete_main_channel',
          [HttpErrorCode.FORBIDDEN]: 'error.chat_participants.forbidden_delete',
        },
      },
      onSuccess: async () => {
        await dispatch(getConversations());
      },
    });

  return { deleteChannel, isDeletingChannel };
};
